var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBatteryLow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 11,
    viewBox: "0 0 21 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.69225 11C1.94442 11 1.30875 10.7382 0.78525 10.2148C0.26175 9.69125 0 9.05558 0 8.30775V2.69225C0 1.94442 0.26175 1.30875 0.78525 0.785249C1.30875 0.261749 1.94442 0 2.69225 0H16C16.7478 0 17.3835 0.261749 17.907 0.785249C18.4305 1.30875 18.6923 1.94442 18.6923 2.69225V8.30775C18.6923 9.05558 18.4305 9.69125 17.907 10.2148C17.3835 10.7382 16.7478 11 16 11H2.69225ZM4.5 9.5H16C16.3347 9.5 16.6171 9.38575 16.8472 9.15725C17.0773 8.92875 17.1923 8.64558 17.1923 8.30775V2.69225C17.1923 2.35442 17.078 2.07125 16.8495 1.84275C16.621 1.61425 16.3378 1.5 16 1.5H4.5V9.5ZM19.6923 7.80775V3.202H20.096C20.3522 3.202 20.5668 3.28858 20.74 3.46175C20.9133 3.63508 21 3.84975 21 4.10575V6.90375C21 7.15992 20.9133 7.37458 20.74 7.54775C20.5668 7.72108 20.3522 7.80775 20.096 7.80775H19.6923Z",
    fill: "#DC2626"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryLow);
export default __webpack_public_path__ + "static/media/battery_low.4607825f.svg";
export { ForwardRef as ReactComponent };